<template>
    <div style="margin-top: 100px; margin-bottom: 100px">
        <div class="container-bg" style="margin-top: 5% !important; width: 45%; margin: auto">
            <div class="container-fg">
                <div style="display: flex; flex-direction: row">
                    <img style="width: 130px; margin-bottom: 1%" src="../../assets/logos/getac-logo.svg" />
                    <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">PAY QUOTE</div>
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div style="display: flex; flex-direction: row">
                    <div style="display: block; margin: auto">
                        <div v-if="responseCode === '1'">
                            <p
                                class="text-h7 nav-font text-center"
                                style="display: block; margin: auto; margin-top: 25%"
                                >QUOTE {{ quoteId }} SUCCESSFULLY</p
                            >
                            <h1
                                style="font-size: 36px; letter-spacing: -0.08rem; margin-bottom: 10%"
                                class="text-center"
                                >PAID & COMPLETED</h1
                            >
                        </div>
                        <div v-else>
                            <h1
                                style="font-size: 36px; letter-spacing: -0.08rem; margin-bottom: 10%"
                                class="text-center"
                                >Failed to Pay the Quote {{ quoteId }}</h1
                            >
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <v-snackbar v-model="snackbar" color="error">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
    name: 'AuthNetPaymentResponse',
    data() {
        return {
            responseCode: this.$route.params.responseCode || this.$route.query.responseCode,
            transId: this.$route.params.transId || this.$route.query.transId,
            quoteId: this.$route.params.quoteId || this.$route.query.quoteId,
            method: this.$route.params.method || this.$route.query.method,
            snackbar: false,
            snackbarMessage: ''
        }
    },
    mounted() {
        // this.confirmPayment()
    },
    methods: {
        showMessage(message) {
            this.snackbar = true
            this.snackbarMessage = message
        },
        async confirmPayment() {
            // check quote id
            if (this.responseCode !== '1' || !this.quoteId || !this.transId) return
            this.submitting = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation ConfirmAuthNetPayment($transId: String!, $quoteId: String!) {
                            confirmAuthNetPayment(transId: $transId, quoteId: $quoteId) {
                                payment {
                                    uid
                                    source
                                    url
                                    status
                                    transaction
                                    adminStatus
                                }
                            }
                        }
                    `,
                    variables: {
                        quoteId: this.quoteId,
                        transId: this.transId
                    }
                })
                .catch((errors) => {
                    this.showMessage(errors)
                })
        }
    }
}
</script>
